import axios from 'axios';


const api_base_url = "https://deliverybackend.com/frootwheelapi/V1"

var openapi_server = axios.create({
    baseURL: api_base_url,
    headers: {
        'Content-Type': 'application/json'
    }
});

const getConfig = headerparams => { return { headers: { 'authorization': localStorage.getItem('lvlacc') || 'newnlp', ...headerparams } }; };



export const checkCode = (params, headerparams) => {

    var myformData = new FormData();

    myformData.set('f', 'checkcode');
    myformData.set('code', params.code);

    return openapi_server.post(
        `frootwheelapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const spinTheWheel = (params, headerparams) => {

    var myformData = new FormData();

    myformData.set('f', 'spinwheel');
    myformData.set('code', params.code);
    myformData.set('name', params.name);
    myformData.set('phone', params.phone);

    return openapi_server.post(
        `frootwheelapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getWinnerVideo = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'getfile');
    myformData.set('vcode', params.vcode);
    return openapi_server.post(
        `getfile.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}



